import "core-js/modules/es.array.concat.js";
import React, { createContext, useContext, useRef, useEffect } from 'react';
var DocumentTitleContext = /*#__PURE__*/createContext(undefined);

/**
 * This approach for adding a custom context hook was taken from the following article:
 * https://reacttraining.com/blog/react-context-with-typescript/
 */

function useDocumentTitleContext() {
  var context = useContext(DocumentTitleContext);
  if (context === undefined) {
    throw Error('useDocumentTitleContext must be used inside of a DocumentTitleProvider');
  }
  return context;
}
function DocumentTitleProvider(_ref) {
  var _ref$baseTitle = _ref.baseTitle,
    baseTitle = _ref$baseTitle === void 0 ? '' : _ref$baseTitle,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(DocumentTitleContext.Provider, {
    value: {
      baseTitle: baseTitle,
      isDisabled: isDisabled
    }
  }, children);
}
function useSetDocumentTitle(pageTitle) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$isDisabled = _ref2.isDisabled,
    isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled;
  var prevTitleRef = useRef(document.title);
  var _useDocumentTitleCont = useDocumentTitleContext(),
    baseTitle = _useDocumentTitleCont.baseTitle,
    globalIsDisabled = _useDocumentTitleCont.isDisabled;
  var disabled = isDisabled || globalIsDisabled;
  useEffect(function () {
    if (disabled || !pageTitle || typeof pageTitle !== 'string') {
      return;
    }
    if (pageTitle !== prevTitleRef.current) {
      prevTitleRef.current = document.title;
      var newTitle = baseTitle ? "".concat(pageTitle, " - ").concat(baseTitle) : pageTitle;
      document.title = newTitle;
      return function () {
        document.title = prevTitleRef.current;
      };
    }
  }, [baseTitle, pageTitle, disabled]);
}
export { useSetDocumentTitle, DocumentTitleProvider };